import {MenuItem, MenuItemProps} from '@mui/material';
import {useCallback} from 'react';
import {NavigateOptions, To, useNavigate} from 'react-router';
import {ComponentWithRequiredChildren, PropsWithRequiredChildren} from '../react/types';

type AllowedMenuItemProps = Omit<MenuItemProps, 'children' | 'onClick'>;

interface MenuItemLinkProps extends PropsWithRequiredChildren, AllowedMenuItemProps {
  navigateOptions?: NavigateOptions;
  to: To;
}

export const MenuItemLink: ComponentWithRequiredChildren<MenuItemLinkProps> = ({
  children,
  navigateOptions,
  to,
  ...menuItemProps
}: MenuItemLinkProps) => {
  const navigate = useNavigate();
  const doNavigate = useCallback(() => void navigate(to, navigateOptions), [navigate, to, navigateOptions]);
  return (
    <MenuItem {...menuItemProps} onClick={doNavigate}>
      {children}
    </MenuItem>
  );
};
